var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.value)+" "),_c('span',{staticClass:"ma-1",attrs:{"title":"Позвонить"},on:{"click":function($event){return _vm.$root.$emit('ddd', _vm.value)}}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("fas fa-pen-nib")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }